module.exports = __webpack_public_path__ + "static/media/Katty-Lynch-Serif.154def9b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Katty-Lynch-Serif.woff2
// module id = 3252
// module chunks = 70